/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useParams } from 'react-router-dom';
import useProcedures from './useProcedures';

/**
 * Hook to return the initial submission procedure for the currently used procedure from the route parameters.
 * The result delivers the initial procedure configuration object if the current procedure has such a dependency
 * or null otherwise
 */
export default function useInitialSubmissionProcedure() {
  const { initialSubmissionProcedure } = useParams();
  const { getProcedure } = useProcedures();

  if (initialSubmissionProcedure) {
    return getProcedure(initialSubmissionProcedure);
  }

  return null;
}
